export const COLORS = {
    white: '#fff',
    black: '#000',
    primary:"#124270"
  }